import React from "react";

import {
  Box,
  Card,
  CardHeader,
  Divider,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { times } from "lodash";

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(2),
  },
  box: {
    display: "flex",
    flexDirection: "column",
  },
}));

const CardSkeleton = () => {
  const classes = useStyles();

  return (
    <Card>
      <CardHeader title="My lesson types" />
      <Divider />
      {times(3, idx => (
        <Box key={idx}>
          <Grid container className={classes.container}>
            <Box flex={1} className={classes.box}>
              <Skeleton width="160px" height="30px" />
              <Skeleton width="135px" height="30px" />
            </Box>
            <Box alignItems="center" display="flex">
              <Skeleton width="50px" height="30px" />
            </Box>
          </Grid>
        </Box>
      ))}
    </Card>
  );
};

export default CardSkeleton;
